import React, { useEffect, useState } from 'react';
import ModalManager from '../services/ModalManager';
import './Modal.css';

const Modal = () => {
  const [state, setState] = useState({ open: false });

  useEffect(() => {
    return ModalManager.subscribe(setState);
  }, []);

  if (!state.open) return null;

  const Content = state.content;

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true" onClick={()=>ModalManager.close()}>
      <div className="modal-window" onClick={e=>e.stopPropagation()}>
        <div className="modal-head">
          <strong>{state?.props?.title || 'Info'}</strong>
          <button className="modal-close" aria-label="Close" onClick={()=>ModalManager.close()}>&times;</button>
        </div>
        <div className="modal-body">
          {Content ? <Content {...state.props} /> : null}
        </div>
      </div>
    </div>
  );
};
export default Modal;
